import PhotoCaptureController from "./photo_capture_controller"

// Photo evidence + AI readout for the attitude fields: the photo (an Airbus
// DMU printout, or any attitude evidence) uploads as levelling evidence;
// when the server has an AI key and the aircraft is an Airbus, the printout
// is transcribed and interpreted server-side and the suggestion lands in the
// still-editable magnitude and attitude fields.
export default class extends PhotoCaptureController {
  static targets = ["input", "evidence", "status", "magnitude", "attitude"]
  static values = { uploadUrl: String, extractUrl: String, ai: Boolean }

  get thumbAlt() { return "Pitch attitude evidence" }
  get extractionFilename() { return "print.jpg" }
  get savedMessage() { return "Photo saved as attitude evidence." }
  get readingMessage() { return "Photo saved — reading the printout…" }

  uploadFields(body) {
    body.append("weighing_attachment[category]", "levelling")
    body.append("weighing_attachment[caption]", "Pitch attitude evidence")
  }

  magnitudeEdited() {
    if (this.filling) return
    this.magnitudeTarget.classList.remove("ai-filled")
    if (this.hasAttitudeTarget) this.attitudeTarget.classList.remove("ai-filled")
  }

  applyExtraction(data) {
    if (!data.found) {
      const notes = data.notes ? ` (${data.notes})` : ""
      this.setStatus(`Photo saved — the printout could not be read${notes}. Enter the value manually.`, "warn")
      return
    }

    const readout = (data.sources || []).map((s) => `${s.source} ${s.raw}`).join(" · ")
    const warnings = (data.warnings || []).join(" ")

    if (data.suggested_magnitude == null) {
      this.setStatus(`Print read: ${readout || "no pitch values found"}. ${warnings || "Enter the value manually."}`.trim(), "warn")
      return
    }

    const summary = `${readout} → ${data.suggested_magnitude}° ${data.suggested_attitude}`
    const current = this.magnitudeTarget.value.trim()

    if (current === "") {
      this.fillField(this.magnitudeTarget, data.suggested_magnitude)
      if (this.hasAttitudeTarget) this.fillField(this.attitudeTarget, data.suggested_attitude, "change")
      this.setStatus(`Print read: ${summary} (${data.confidence} confidence). ${warnings} Verify against the photo — both fields stay editable.`.replace(/\s+/g, " "), warnings ? "warn" : "ok")
    } else if (Number(current) === Number(data.suggested_magnitude) && this.attitudeTarget?.value === data.suggested_attitude) {
      this.setStatus(`Print read: ${summary} — matches the entered attitude. ${warnings}`.trim(), warnings ? "warn" : "ok")
    } else {
      this.setStatus(`Print read: ${summary} — differs from the entered ${current}° ${this.attitudeTarget?.value || ""}. Check the photo. ${warnings}`.replace(/\s+/g, " "), "warn")
    }
  }
}
